export default [
    {
        path: 'relatorio-cota-profissional',
        component: () => import(
            /* webpackChunkName: 'exame-imagem-relatorio-cota-profissional' */
            '@/views/exame-imagem/relatorio-cota-profissional/Index'),
        redirect: 'relatorio-cota-profissional/index',
        children: [
            {
                name: 'exame-imagem-relatorio-cota-profissional-index',
                path: 'index',
                component: () => import(
                    /* webpackChunkName: 'exame-imagem-relatorio-cota-profissional' */
                    '@/views/exame-imagem/relatorio-cota-profissional/List.vue'),
            },
        ],
    },
]